$.flash = (severity, message, timeout) ->
  AUTOHIDE_SEVERITIES = ["success", "notice"]

  timeout = timeout || 4000

  # Build the close button
  closeButton = $("<a>")
    .addClass("close-button")
    .click (e) ->
      $.flash.hide()
      e.preventDefault()

  # Build the flash element and add it to the DOM
  flash = $("<div>")
    .attr("id", "flash")
    .addClass(severity)
    .html(message)
    .append(closeButton)
    .click((e) ->
      $.flash.hide()
      e.preventDefault()
    )
    .find("a")
      .click((e) -> e.stopPropagation())
      .end()
    .prependTo($("body"))

  setTimeout ->
    flash.addClass("enter")
  , 0

  # Auto-hide certain types of message
  setTimeout $.flash.hide, timeout if AUTOHIDE_SEVERITIES.indexOf(severity) >= 0

  flash

$.flash.hide = () ->
  flash = $("#flash")
  flash
    .addClass("hide")
    .removeClass("enter")
    .one "webkitAnimationEnd oanimationend msAnimationEnd animationend", ->
      flash.remove()

$("meta[name^='flash']").each ->
  $this = $(this)

  severity = $this.attr("name").split("-")[1]
  message = $this.attr("content")
  $.flash severity, message
